import styled from 'styled-components';
import { rgba } from 'polished';
import { Link } from 'react-router-dom';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';
import media from '../../styles/config/mediaQueries';

const StyledContainer = styled.div`
  .swiper-slide {
    width: 100%;
    max-width: 150px;
  }
  ${media.desktop`
    display: flex;
    flex-direction: ${props => (props.type === 'sidebar' ? 'column' : 'row')};
    flex-wrap: ${props => (props.type === 'sidebar' ? 'nowrap' : 'wrap')};
  `}
`;

const StyledStoryContainer = styled.div`
  display: flex;
  flex-direction: ${props => (props.type === 'sidebar' ? 'row' : 'column')};
  align-items: ${props => (props.type === 'sidebar' ? 'center' : 'flex-start')};
  width: ${props => (props.type === 'sidebar' ? '100%' : 'calc(25% - 16px)')};
  padding: ${props => (props.type === 'sidebar' ? '7px' : '0')};
  padding-left: 0;
`;

const StyledContentWrapper = styled.div`
  color: ${() => theme.color.white};
`;

const StyledLink = styled(Link)`
  display: inline-block;
  width: 100%;
`;

const StyledPhoto = styled.img`
  width: 100%;
  object-fit: cover;
  object-position: top;
  ${media.mobile`
    height: ${props => (props.mobileShort ? '111px' : '150px')};
    margin-bottom: ${props => (props.mobileShort ? '0' : '12px')};
    border-radius: 4px;
  `}
  ${media.desktop`
    height: ${props => (props.type === 'sidebar' ? '111px' : '214px')};
  `}
`;

const StyledPhotoLink = styled(Link)`
  display: inline-block;
  width: 100%;
  max-width: ${props => (props.type === 'sidebar' ? '79px' : '177px')};
  margin-right: ${props => (props.type === 'sidebar' ? '15px' : '0')};
  margin-bottom: ${props => (props.type === 'sidebar' ? '0' : '6px')};
  border-radius: ${props => (props.type === 'sidebar' ? '6px' : '4px')};
  overflow: hidden;
`;

const StyledAuthor = styled.span`
  display: block;
  ${typeStyle['font-10']};
  ${media.mobile`
    margin-bottom: 8px;
    padding: 0 5px;
  `}
  ${media.desktop`
    margin-bottom: 3px;
    line-height: 15px;
  `}
`;

const StyledTitleWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const StyledTitle = styled.h3`
  text-transform: uppercase;
  ${media.mobile`
    padding: 0 5px;
    ${typeStyle.h3};
  `}
  ${media.desktop`
    ${typeStyle.h4}
  `}
`;

const StyledButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledLikeButton = styled.button`
  width: 26px;
  height: 26px;
`;

const StyledOptionsButton = styled.button`
  width: 20px;
  height: 20px;
`;

const StyledButton = styled.button`
  svg {
    width: 28px;
    margin-bottom: 8px;
  }

  span {
    text-transform: uppercase;
    ${media.mobile`
      ${typeStyle['font-14-semi-bold']};
    `}
    ${media.desktop`
      ${typeStyle.h4};
    `}
  }
  ${media.mobile`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    width: 100%;
    height: 150px;
    margin-top: 30px;
    background-color: ${rgba(theme.color.black, 0.1)};
    border: 1px solid ${() => rgba(theme.color.white, 0.1)};
  `}
  ${media.desktop`
    margin-top: 16px;
    color: ${rgba(theme.color.white, 0.3)};
  `}
`;

const StyledFullWidth = styled.div`
  width: calc(100% - 24px);
`;

export {
  StyledContainer,
  StyledLink,
  StyledContentWrapper,
  StyledTitleWrapper,
  StyledPhoto,
  StyledAuthor,
  StyledTitle,
  StyledStoryContainer,
  StyledPhotoLink,
  StyledButton,
  StyledButtonsWrapper,
  StyledLikeButton,
  StyledOptionsButton,
  StyledFullWidth,
};
